var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_9962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8604 38C29.7951 38 29.7299 38 29.6646 37.9966C27.6854 37.9106 25.2494 36.4738 24.3576 32.6925L22.1065 23.1294L20.6203 29.0144C20.3085 30.2519 19.1413 31.125 17.8 31.125H14.9C13.2977 31.125 12 29.8944 12 28.375C12 26.8556 13.2977 25.625 14.9 25.625H15.5126L16.6255 21.2181C17.5571 17.375 20.0693 16 22.1138 16H22.1283C24.18 16.0069 26.703 17.4025 27.6237 21.3041L29.9003 30.9669L30.9769 27.5809C31.3466 26.4191 32.474 25.625 33.7536 25.625H38.1036C39.7059 25.625 41.0036 26.8556 41.0036 28.375C41.0036 29.8944 39.7059 31.125 38.1036 31.125H35.9069L35.1348 33.5553C34.0146 36.8519 31.7164 38 29.864 38H29.8604Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_9962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 22,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacLine);
export default __webpack_public_path__ + "static/media/contac_line.7944ef63cbd639ab32d55f484b5ba1b0.svg";
export { ForwardRef as ReactComponent };